import { createAsyncThunk } from '@reduxjs/toolkit';
import Api from '../../api';

export const getComprehensivePage = createAsyncThunk('comprehensivePage/getComprehensivePage', async (payload, thunkAPI) => {
  try {
    const { data } = await Api.getComprehensivePage();
    return data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e.response.data);
  }
});
